module.exports = __webpack_public_path__ + "media/icons/clock-6490cd53.png";